export default __webpack_public_path__ + "img/fyCBugBR.105941d2.svg";